@use '../../../common/styles/variables' as *;
@use '../../../common/mixins/inputs' as *;

:host {
  display: block;
  @include default-css-variables;
  width: inherit;
}

.nylas-event-capacity {
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    display: flex;
    align-items: center;
    gap: 4px;
    color: var(--nylas-base-800);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;

    /* 21px */
    span.required {
      color: var(--nylas-error, #cc4841);
    }

    span.label-icon {
      margin-left: 4px;

      tooltip-component {
        display: flex;
      }
    }

    tooltip-component {
      &::part(tc__content) {
        left: 50px;
      }
    }
  }
}

.nylas-event-capacity__wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;

  input-component {
    width: auto;
  }

  input-component::part(ic__input) {
    border-width: 1;
    border-radius: 8px;
    border: 1px solid var(--nylas-base-200);
    font-family: var(--nylas-font-family);
    font-size: 16px;
    line-height: 24px;
    width: 80px;
  }

  input-component::part(ic__input--error) {
    border: 1px solid var(--nylas-error);
  }

  input-component::part(ic__label--error) {
    position: relative;
    margin-bottom: 24px;
  }

  input-component::part(ic__error_message) {
    position: absolute;
    top: 54px;
    width: max-content;
  }

  span.attendees {
    &.error {
      margin-top: -24px;
    }
  }
}
